import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Container, Row, Col, Form, Button } from "react-bootstrap";

const UpdatePengiriman = () => {
  const [updatePengirimanId, setUpdatePengirimanId] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (updatePengirimanId === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "ID driver tidak boleh kosong!",
      });
      return;
    }

    try {
      const { value: formValues } = await Swal.fire({
        title: "Update Pengiriman",
        html: `
          <div style="text-align: center; margin: auto; max-width: 800px;">
            <div style="margin-top: 20px; text-align: left;">
              <label for="statusPengiriman" 
              style="display: block; 
              font-weight: bold; 
              margin-bottom: 10px;">Status Pengiriman:</label>

              <select id="statusPengiriman" 
              style="width: 100%; 
              padding: 10px; 
              border: 1px solid #ddd; 
              border-radius: 5px;">
                <option value="" disabled selected>Pilih status pengiriman</option>
                <option value="dikirim">Sedang dalam pengiriman</option>
                <option value="diterima">Telah diterima</option>
              </select>
            </div>
            <div style="margin-top: 20px; text-align: left;">
              <label for="lokasiSaatIni" 
              style="display: block; 
              font-weight: bold; 
              margin-bottom: 10px;">Lokasi Saat Ini:</label>
              <input type="text" id="lokasiSaatIni" placeholder="Tulis lokasi Anda saat ini..." 
              style="width: 100%; 
              padding: 10px; 
              border: 1px solid #ddd; 
              border-radius: 5px;" />
            </div>
          </div>
        `,
        focusConfirm: false,
        showCancelButton: true,
        preConfirm: () => {
          const statusPengiriman =
            document.getElementById("statusPengiriman").value;
          const lokasiSaatIni = document
            .getElementById("lokasiSaatIni")
            .value.trim();

          if (!statusPengiriman || !lokasiSaatIni) {
            Swal.showValidationMessage(
              "Harap pilih status pengiriman dan isi lokasi saat ini!"
            );
            return;
          }

          return { statusPengiriman, lokasiSaatIni };
        },
      });

      if (!formValues) {
        return; // User canceled the dialog
      }

      const { statusPengiriman, lokasiSaatIni } = formValues;
      const response = await axios.post(
        "https://c-greenproject.org:7500/update_pengiriman",
        {
          kode_unik: updatePengirimanId,
          status: statusPengiriman,
          lokasi: lokasiSaatIni,
        }
      );

      const result = response.data;

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Data Berhasil Disimpan",
          text: result.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: result.error || "Terjadi kesalahan saat memperbarui data.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Kode unik tidak valid atau truk tidak ditemukan.",
      });
    }
  };

  return (
    <div
      id="updatePengirimanSection"
      style={{ backgroundColor: "#ffffff", padding: "30px 0" }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} md={8} lg={6}>
            <h2
              className="text-center fw-bold mb-2"
              style={{
                color: "#00d8cb",
                fontFamily: "Ubuntu, sans-serif",
              }}
            >
              Update Pengiriman
            </h2>

            <Form onSubmit={handleSubmit} className="p-4 ">
              <Form.Group className="mb-3" controlId="updatePengirimanId">
                <Form.Label className="fw-bold fs-6">
                  Masukkan ID driver :
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Masukkan ID driver Anda"
                  value={updatePengirimanId}
                  onChange={(e) => setUpdatePengirimanId(e.target.value)}
                  required
                  style={{ borderRadius: "8px" }}
                />
              </Form.Group>

              <div className="text-center">
                <Button
                  type="submit"
                  style={{
                    backgroundColor: "#28dbcf",
                    borderRadius: "15px",
                    padding: "10px 20px",
                    color: "#ffffff",
                    border: "3px solid #ffffff",
                  }}
                >
                  Cek
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UpdatePengiriman;
